module.exports = __webpack_public_path__ + "static/media/icon-new-year-event.422d92f3.png";